import React from 'react';
import messages from './translations';
import Router from './Router';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as icons from './icons';
import AppProvider from '@afosto/app-components-react/AppProvider';
import SessionManager from '@afosto/auth/SessionManager';

SessionManager.client = {
  id: process.env.REACT_APP_CLIENT_ID,
  scopes: [
    'iam:audits:read',
    'iam:customer:read',
    'iam:customer:write',
    'iam:logs:read',
    'iam:sources:read',
    'iam:sources:write',
    'iam:oauth:read',
    'iam:oauth:write',
    'iam:roles:read',
    'iam:roles:write',
    'iam:subscriptions:read',
    'iam:tenants:read',
    'iam:users:read',
    'iam:users:write',
    'iam:2fa:write',
    'iam:2fa:read',
    'app:integrations:read',
    'app:integrations:write',
    'cat:channel:read',
    'cat:channel:write',
    'cnt:index:read',
    'cnt:index:write',
    'cnt:files:read',
    'cnt:files:write',
    'lcs:handling:read',
    'lcs:handling:write',
    'lcs:locations:read',
    'lcs:locations:write',
    'odr:transactions:create',
    'odr:invoices:read',
    'odr:invoices:update',
    'odr:orders:read',
    'odr:orders:write',
    'odr:providers:read',
    'odr:payments:update',
    'cat:prices:read',
    'rel:contacts:read',
    'rel:contacts:write',
    'rel:identity:read',
    'rel:identity:write',
    'mes:inboxes:read',
    'mes:inboxes:write',
    'wms:location:read',
    'wms:location:write',
    'wms:transfer:read',
    'wms:transfer:write',
    'wms:claim:read',
    'wms:claim:write',
    'wms:route:read',
    'wms:route:write',
  ],
};

library.add(icons);

const App = () => (
  <AppProvider app="iam" messages={messages}>
    <Router />
  </AppProvider>
);

export default App;
